<template>
  <v-container class="gray pa-3 ma-0 fluid subtitle-1 text-justify">
    <h1 class="mt-4">Instalação do Wails</h1>
    <br />
    <v-layout>
      <v-flex>
        <v-row>
          <v-col class="col-10 offset-1">
            <p>Finalmente chegamos na instalação do Wails...</p>
          </v-col>

          <v-col class="col-6 offset-3">
            <a target="_blank" href="https://wails.app/">Site do Wails</a>
          </v-col>

          <v-col class="col-6 offset-3">
            <v-img src="@/assets/wails.jpg"></v-img>
          </v-col>

          <v-col class="mt-3 col-10 offset-1">
            <p>A instalação do Wails é um pouco diferente das outras ferramentas que vimos até agora.</p>
            <p>Não tem um instalador para o Wails. Para instalar a ferramenta, abra uma janela de console e digite:</p>
            <p>
              <code class="black subtitle-1">go get -u github.com/wailsapp/wails/cmd/wails</code>
            </p>
            <p>Pronto! Só aguardar...</p>
            <p>A partir deste momento estamos prontos para brincar com o Wails e descobrir todas suas possibilidades!</p>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="col-1 offset-9">
            <v-btn class="primary" to="/firsttest">Funcionando...</v-btn>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
    <v-btn fab dark large color="success" fixed right bottom @click="GoTop()">
      <v-icon dark>mdi-arrow-up-bold</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
export default {
  name: "Installwails",
  mounted() {
    this.$vuetify.goTo(0);
  },
  methods: {
    GoTop() {
      this.$vuetify.goTo(0);
    }
  }
};
</script>
